export default function glitchEffect() {
  const text = "Portfolio";
  const element = document.getElementById("glitch-heading");
  const chars = "<0110·1100·1111>________";
  let iterations = 0;

  // Exit if element is not found
  if (!element) return;

  // Ensure original text is visible at the start
  element.innerText = text;

  const glitchInterval = setInterval(() => {
    element.innerText = text
      .split("")
      .map((char, i) => {
        if (i < iterations) return text[i];
        return chars[Math.floor(Math.random() * chars.length)];
      })
      .join("");

    iterations += 0.5;

    if (iterations >= text.length) {
      clearInterval(glitchInterval);
      element.innerText = text; // Restore full text when done
    }
  }, 50);
}
